<template>
  <div>
    <div v-if="loading" class="text-center text-success my-2">
      <div class="spinner-border align-middle me-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <strong>Loading...</strong>
    </div>
    
    <div v-else class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>Type</th>
            <th>Group</th>
            <th>Survey Name</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredSurveys" :key="item.id">
            <td>{{ item.id }}</td>
            <td>
              <span class="icon-bullet-list"></span>
              <span class="survey-type-pill col-3"><strong>{{ item.survey_type_id }}</strong></span>
            </td>
            <td>
              <span :class="`${anon ? 'g-anon' : '' }`">
                {{ item.group_id }}
              </span>
            </td>
            <td>
              <span :class="`${anon ? 'g-anon' : '' }`">
                {{ item.survey_name }}
              </span>
            </td>
            <td>{{ item.survey_start_date }}</td>
            <td>{{ item.survey_end_date }}</td>
            <td>
              <SurveyProgressBar
                :survey_id="item.id"
                :progressvalue="item.completecount"
                :progressmax="item.membercount"
                :progressvariant="(item.completecount == item.membercount)?'bg-success':'bg-default'"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import SurveyProgressBar from './SurveyProgressBar.vue';

  const fields = [
    {key: 'id',sortable: true, label: 'ID' },
    {key: 'survey_type_id',sortable: true,label: 'Type'},
    {key: 'group_id',sortable: true, label: 'Group'},
    {key: 'survey_name',sortable: true},
    {key: 'survey_start_date',sortable: true},
    {key: 'survey_end_date',sortable: true},
    {key: 'survey_status',sortable: false, label: 'Progress'},
  ];
  export default {
    components: {
      SurveyProgressBar
    },
    name: 'ConsultantSurveys',
    created() {
      this.consultantsurveys_get()
    },
    data: function() {
      return {
        currentPage: 1,
        perPage: 10,
        rows: 0,
        loading: null,
        orderby: 'group_name',
        orderdesc: false,
        fields: fields,
        consultant: {},
        consultantsurveys: [],
        surveycount_1: 0,
        surveycount_2: 0,
        surveycount_3: 0,
        surveycount_4: 0,
        surveycount_deleted: 0,
      }
    },
    computed: {
      anon: function() {
        return this.$store.state.anon;
      },
      filteredSurveys() {
        if (!this.surveytype) {
          return this.consultantsurveys;
        }
        return this.consultantsurveys.filter(row => this.filter_it(row, this.surveytype));
      }
    },
    methods: {
     saverowfield() {
     },
     showdetails(item) {
       item._showDetails = !item._showDetails;
     },
     consultantsurveys_get() {
       this.loading = true;
        var filter = {        }
        this.$store.dispatch('admin_consultantsurveys_fetch', {
          user_id: this.$store.state.currentconsultant_id,
          start: (this.currentPage-1)*this.perPage,
          limit: this.perPage,
          orderby: this.orderby,
          order: (this.orderdesc==false)?'ASC':'DESC',
          filter: filter,
        })
        .then((resp) => {
          var consultantsurveys = [];
          var surveycount_1 = 0;
          var surveycount_2 = 0;
          var surveycount_3 = 0;
          var surveycount_4 = 0;
          var surveycount_deleted = 0;
         
          for (var i=0;i<resp.data.result.length;i++) {
            var result = {
              id: resp.data.result[i].id,
              selected: false,
              survey_name: resp.data.result[i].survey_name,
              survey_start_date: resp.data.result[i].survey_start_date,
              survey_end_date: resp.data.result[i].survey_end_date,
              survey_type_id: resp.data.result[i].survey_type_id,
              group_id: resp.data.result[i].group_id,
              survey_status_name: resp.data.result[i].survey_status_name,
              survey_status_id: resp.data.result[i].survey_status_id,
              survey_status: resp.data.result[i].completecount+' / '+resp.data.result[i].membercount,
              completecount: resp.data.result[i].completecount,
              membercount: resp.data.result[i].membercount,
              survey_deleted: resp.data.result[i].survey_deleted,
              _showDetails: false,
            }
            if (result.survey_deleted == 1) {
              surveycount_deleted++
            } else {
              eval('surveycount_' + result.survey_status_id + '++')
            }
            consultantsurveys.push(result);
          }
          this.surveycount_1 = surveycount_1;
          this.surveycount_2 = surveycount_2;
          this.surveycount_3 = surveycount_3;
          this.surveycount_4 = surveycount_4;
          this.surveycount_deleted = surveycount_deleted;
          this.consultantsurveys = consultantsurveys;
          this.rows = resp.data.total;
          this.loading = false;
        });
      },
      filter_it(row,filter) {
        var include = true
        if (filter == 'drafts') {
          if (row.survey_status_id != 1 || row.survey_deleted == 1) {
            include = false
          }
        }
        if (filter == 'upcoming') {
          if (row.survey_status_id != 2 || row.survey_deleted == 1) {
            include = false
          }
        }
        if (filter == 'ongoing') {
          if (row.survey_status_id != 3 || row.survey_deleted == 1) {
            include = false
          }
        }
        if (filter == 'finished') {
          if (row.survey_status_id != 4 || row.survey_deleted == 1) {
            include = false
          }
        }
        if (filter == 'deleted') {
          if (row.survey_deleted != 1) {
            include = false
          }
        }
        return include
      },
      format_date(date) {
        var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');
      },
      format_time(date) {
        var d = new Date(date);
        var h = d.getHours();
        var m = d.getMinutes();
        var hour = (h>9?'':'0')+h;
        var minute = (m>9?'':'0')+m;
        var thistime = hour+':'+minute;
        return thistime;
      },
    },
    props: ['surveytype'],
  }
</script>
<style>
</style>
